import { render, staticRenderFns } from "./SubjectReaction.vue?vue&type=template&id=db04b282&scoped=true&"
import script from "./SubjectReaction.vue?vue&type=script&lang=ts&"
export * from "./SubjectReaction.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectReaction.vue?vue&type=style&index=0&id=db04b282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db04b282",
  null
  
)

export default component.exports